/* ============================================================
   sb-hub-form.js — Conversion-Signale der Hub-Formulare
   ============================================================
   Eingebunden von sections/sb-hub-form.liquid, nur wenn dort ein
   Tracking-Name gesetzt ist.

   Einbett-Vertrag v2 (26.09.2026): embed.js vom Hub feuert am
   Formular-Container die DOM-Ereignisse sb-form:started und
   sb-form:submitted (bubbles, detail {form, lang}, je einmal pro
   Container, ohne Personendaten). embed.js misst selbst nichts —
   die Seite entscheidet mit ihrer Einwilligung, ob und wohin das
   Ereignis geht. Genau das tut diese Datei:

     sb-form:started    → Shopify.analytics.publish('<name>_start')
     sb-form:submitted  → Shopify.analytics.publish('<name>_submit')

   <name> kommt aus dem Section-Setting tracking_name, als
   data-sb-hub-form-tracking am Section-Wurzelelement. Auf /b2b ist
   das dealer_registration.

   ── Warum Shopify.analytics.publish und nicht dataLayer ─────
   Gemessen am 26.09.2026 auf Live (Theme 202572824918): GA4 und
   Meta laufen ausschliesslich als App-Pixel in Shopifys Pixel-
   Sandbox. Auf der Seite gibt es weder GTM noch gtag noch fbq,
   window.dataLayer existiert nicht — ein push dorthin liest
   niemand. Eigene Ereignisse erreichen die Pixel nur ueber
   Shopify.analytics.publish; abonniert werden sie von einem
   Benutzerdefinierten Pixel (Einstellungen → Kundenereignisse),
   das sie an GA4 und Meta weitergibt. Code und Einrichtung stehen
   in der PR-Beschreibung.

   ── Einwilligung, zweimal ──────────────────────────────────
   1. Hier: veroeffentlicht wird nur, wenn der eigene Banner eine
      Entscheidung mit Statistik oder Marketing gespeichert hat
      (SBConsent.get(), assets/sb-consent.js). Ohne gueltiges
      sb_consent-Cookie liefert get() null — dann geht nichts raus.
   2. Bei Shopify: jedes Pixel traegt seine eigenen Berechtigungen
      (Analyse bzw. Marketing) und bekommt Ereignisse nur, wenn
      customerPrivacy sie erlaubt; sb-consent.js spiegelt die
      Entscheidung dorthin.

   ── Keine Section-Initialisierung ──────────────────────────
   Ein einziger Listener am document, die Ereignisse bubblen vom
   Container hoch. Nach einem Section-Reload im Theme-Editor gibt
   es also nichts neu zu binden, und shopify:section:load braucht es
   nicht. Der globale Guard verhindert doppelte Listener, wenn zwei
   Sections die Datei einbinden.
   ============================================================ */

(function () {
  if (window.__sbHubFormTracking) return;
  window.__sbHubFormTracking = true;

  var SUFFIX = {
    'sb-form:started': '_start',
    'sb-form:submitted': '_submit'
  };

  // Kleinbuchstaben, Ziffern, Unterstrich — so, wie GA4 Ereignisnamen
  // annimmt. Hoechstens 32 Zeichen, mit Suffix _submit also 39; GA4
  // erlaubt 40.
  var NAME = /^[a-z][a-z0-9_]{0,31}$/;

  function consentAllows() {
    var api = window.SBConsent;
    var rec = api && typeof api.get === 'function' ? api.get() : null;
    return !!(rec && (rec.a === 1 || rec.m === 1));
  }

  function onFormEvent(e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var root = target.closest('[data-sb-hub-form-tracking]');
    var name = root ? root.getAttribute('data-sb-hub-form-tracking') : '';
    if (!name || !NAME.test(name)) return;

    if (!consentAllows()) return;

    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;

    var d = e.detail || {};
    try {
      analytics.publish(name + SUFFIX[e.type], {
        form: String(d.form || ''),
        lang: String(d.lang || '')
      });
    } catch (err) {
      // Messen darf die Seite nie stoeren.
    }
  }

  document.addEventListener('sb-form:started', onFormEvent);
  document.addEventListener('sb-form:submitted', onFormEvent);
})();
